'use client';

import { InternalLinkModelPageFieldFragment, SiteLocale } from '@graphql/generated';
import { useAppContext } from '@lib/context/appContext';
import { ReactNode } from 'react';
import { subPaths } from '../../../next.config';

type Props = {
  internalLink: InternalLinkModelPageFieldFragment;
  className?: string;
  title?: string;
  children?: ReactNode;
};

export const InternalLink = ({ internalLink, title = null, children, className }: Props) => {
  const {
    state: { baseUrl, locale },
  } = useAppContext();
  const prefix = `${baseUrl}/${locale}`;

  if (!prefix || !internalLink) {
    return children;
  }

  let path = '';
  switch (internalLink.__typename) {
    case 'ProductRecord':
      path = `/${subPaths.products[locale as SiteLocale]}/${internalLink.slug}`;
      break;
    case 'PageRecord':
      path = `/${internalLink.slug}`;
      break;
    case 'CategoryRecord':
      path = `/${subPaths.categories[locale as SiteLocale]}/${internalLink.slug}`;
      break;
  }
  const url = `${prefix}${path}`;
  return (
    <a href={url} className={className} key={internalLink.id}>
      {title}
      {children}
    </a>
  );
};
